import { DateTime } from 'luxon';
import { TradeRestriction } from '../../models';
import { TradeRestrictionReason } from '../../enums/trade-restriction-reason.enum';

/** Months without an update after which an active trade restriction is flagged for review. */
export const RESTRICTION_STALE_MONTHS = 6;

/**
 * Returns how many whole months an active, non-board-derived trade restriction has gone without an update,
 * or null when it isn't stale. Board-derived rows are excluded because they're maintained through their
 * board seat. Uses Last Modified only.
 */
export function getRestrictionStaleMonths(restriction: TradeRestriction, now: DateTime = DateTime.now()): number | null {
  if (!restriction?.active || restriction.reason === TradeRestrictionReason.BOARD || !restriction.lastModified) {
    return null;
  }
  const months = Math.floor(now.diff(restriction.lastModified, 'months').months);
  return months >= RESTRICTION_STALE_MONTHS ? months : null;
}
